export enum ErrorType {
  ERROR_404 = '404',
  ERROR_500 = '500',
  ERROR_503 = '503',
}
